export const deployInfo = {
  shortSha: 'ab38bb4',
  commitSha: 'ab38bb43648046d779c3c1fb2c807d32fdae83d6',
  rollbar: { webPostToken: '0ba6e92852d34daca1cfa9d0ca291a82' }
}
